/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import { call, put, takeEvery, takeLatest, take, cancel, delay } from 'redux-saga/effects';
import { GET_UNIX_CREDENTIALS, POLL_UNIX_START, POLL_UNIX_STOP } from './actionTypes';
import { fetchUNIXSuccess, fetchUNIXFailure } from './actions';
import { UnixCredentials } from './unixCredentials'

// worker Saga: will be fired on GET_WMI_CREDENTIALS actions


function* fetchUNIXCreds() {
	  try {
	    const response = yield call(UnixCredentials.getUNIX)
	    yield put(fetchUNIXSuccess(response.data))
	  } catch (error) {
	    yield put(fetchUNIXFailure(error))
	  }
	}

	function* pollUNIXCreds() {
	  while (true) {
	    yield delay(30000)
	    yield call(fetchUNIXCreds)
	  }
	}

/*
  Starts fetchWMICreds on each dispatched `GET_WMI_CREDENTIALS` action.
  Allows concurrent fetches of user.
*/

export function* getUnixSaga() {
 yield takeEvery(GET_UNIX_CREDENTIALS, fetchUNIXCreds)
}

export function* unixPollingSaga() {
	  while (true) {
	    const watcherInstance = yield takeLatest(POLL_UNIX_START, pollUNIXCreds)
	    // cancel polling on POLL_HUBS_STOP
	    yield take(POLL_UNIX_STOP)
	    yield cancel(watcherInstance)
	  }
	}
